import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "app/store";

export const selectObjectTypes = (state: RootState) =>
  state.rootReducer.objectTypesStore.objectTypes;

export const selectIsLoadingObjectTypes = (state: RootState) =>
  state.rootReducer.objectTypesStore.isLoadingObjectTypes;

export const selectObjectTypesState = createSelector(
  selectObjectTypes,
  selectIsLoadingObjectTypes,
  (objectTypes, isLoadingObjectTypes) => ({
    objectTypes,
    isLoadingObjectTypes
  })
);
